import { DateRange, PickersShortcutsItem } from '@mui/x-date-pickers-pro';
import {
    addMonths,
    addWeeks,
    endOfMonth,
    endOfWeek,
    startOfDay,
    startOfMonth,
    startOfWeek
} from 'date-fns';
import { TFunction } from 'i18next';

const todayStart = startOfDay(new Date());
const nextWeekStart = startOfWeek(addWeeks(todayStart, 1));
const nextMonthStart = startOfMonth(addMonths(todayStart, 1));

type RangeShortcut = {
    tKey: string;
    value: [Date, Date] | [null, null];
};

const nextWeekRange: RangeShortcut = {
    tKey: 'nextWeek',
    value: [ nextWeekStart, endOfWeek(nextWeekStart) ]
};

const nextMonthRange: RangeShortcut = {
    tKey: 'nextMonth',
    value: [ nextMonthStart, endOfMonth(nextMonthStart) ]
};

const nextMonthFromNowRange: RangeShortcut = {
    tKey: 'nextMonthFromNowRange',
    value: [ todayStart, addMonths(todayStart, 1) ]
};

const next3MonthsFromNowRange: RangeShortcut = {
    tKey: 'next3MonthsFromNow',
    value: [ todayStart, addMonths(todayStart, 3) ]
};

const resetRange: RangeShortcut = {
    tKey: 'reset',
    value: [ null, null ]
};

const rangeMap = {
    availability: {
        mobile: [
            nextWeekRange,
            nextMonthRange,
            resetRange
        ],
        desktop: [
            nextWeekRange,
            nextMonthRange,
            nextMonthFromNowRange,
            next3MonthsFromNowRange,
            resetRange
        ]
    }
} as const;

export type DateRangePickerShortcutKey = keyof typeof rangeMap;

export function getDateRangePickerShortcuts(key: DateRangePickerShortcutKey, isMobile: boolean, t: TFunction<'common'>): PickersShortcutsItem<DateRange<Date>>[] {
    return rangeMap[key][isMobile ? 'mobile' : 'desktop'].map(range => ({
        label: t(`dateRangePicker.shortcuts.${ range.tKey }`),
        getValue: () => range.value
    }));
}
